import { ValidationBuilder } from "@ajayvikas/react-fluent-validation";
import { CreditCard, PaymentCountry } from "../types";
import t from "../i18n";

export function getValidator(selectedCountry: PaymentCountry | undefined, addressSettings: {
    usUkCa: boolean;
    others: boolean;
}) {
    const isUsUkCa = selectedCountry ? ["US", "GB", "CA"].indexOf(selectedCountry.countryCode) > -1 : false;
    const renderStreetAddress = isUsUkCa ? addressSettings.usUkCa : addressSettings.others;
    const renderCity = isUsUkCa ? addressSettings.usUkCa : addressSettings.others;
    const renderState = isUsUkCa ? addressSettings.usUkCa : false;
    const renderZip = isUsUkCa ? addressSettings.usUkCa : false;
    return new ValidationBuilder<CreditCard>()
        .ensure("creditCardNumber")
        .required().withMessage(t.validations("credit_card_required_validation"))
        .isCreditCard().withMessage(t.validations("credit_card_validation"))
        .ensure("expiryMonthyear")
        .requiredMMYY().withMessage(t.validations("month_required_validation"))
        .isMMYY().withMessage(t.validations("month_validation"))
        .ensure("cvvCode")
        .required().withMessage(t.validations("cvv_required_validation"))
        .ensure("lastName")
        .required().withMessage(t.validations("full_name_required"))
        .if(() => renderStreetAddress)
        .ensure("streetAddress")
        .required().withMessage(t.validations("street_address_required"))
        .endIf()
        .if(() => renderCity)
        .ensure("city")
        .required().withMessage(t.validations("city_required"))
        .endIf()
        .if(() => renderState)
        .ensure("state")
        .required().withMessage(t.validations("state_required"))
        .endIf()
        .ensure("country")
        .required().withMessage(t.validations("country_required"))
        .if(() => renderZip)
        .ensure("zipCode")
        .required().withMessage(t.validations("zip_required"))
        .endIf()
        .build();
}